// extracted by mini-css-extract-plugin
module.exports = {"MainBar":"AppHeader_MainBar__MaP8r","AppHeading":"AppHeader_AppHeading__2gU9V"};